import React, { useEffect } from 'react'
import useAuthenticationStore, { AuthenticationViews } from './Store';
import { useNavigate } from 'react-router-dom';
import ResetPassword from './ResetPassword';

const ResetPasswordContainer: React.FC = () => {
  const { state, finishPasswordReset, isValidPassword, dispatch } = useAuthenticationStore()
  const { serverError, isLoading, emailOrPhone } = state
  const navigate = useNavigate()

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
    }
  }, [emailOrPhone, navigate])

  return (
    <ResetPassword
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      finishPasswordReset={finishPasswordReset}
      isValidPassword={isValidPassword}
      setEmailOrPhone={setEmailOrPhone}
    />
  )
}

export default ResetPasswordContainer;